import * as Headless from "@headlessui/react";
import React, { forwardRef } from "react";
import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router-dom";

type LinkComponentProps = 
  | (RouterLinkProps & { href?: never })
  | (Omit<RouterLinkProps, 'to'> & { href: string; to?: never });

export const Link = forwardRef<HTMLAnchorElement, LinkComponentProps & React.ComponentPropsWithoutRef<"a">>(
  function Link({ href, to, ...props }, ref) {
    // Support both 'to' and 'href' props, convert href to to for React Router
    const destination = to || (href as string);
    
    if (!destination) {
      console.warn('[Link] No destination provided (neither to nor href)');
      return null;
    }
    
    // Exclude 'to' when using 'href' to avoid type conflicts
    const { to: _, ...restProps } = props as any;
    
    return (
      <Headless.DataInteractive>
        <RouterLink 
          {...restProps}
          to={destination}
          ref={ref}
          onClick={(e) => {
            console.log('[Link] Navigating to:', destination);
            // Let RouterLink handle navigation
            if (props.onClick) {
              props.onClick(e);
            }
          }}
        />
      </Headless.DataInteractive>
    );
  }
);
